import { CardAction, ChickletHoverActions, ChickletPrimaryDisplayLabel, CardFooterAction } from '../constants/BehaviorTypes';
import SocialProfileChickletPrimaryDisplayLabel from '../behaviors/socialProfile/SocialProfileChickletPrimaryDisplayLabel';
import SocialProfileCardAction from '../behaviors/socialProfile/SocialProfileCardAction';
import { SocialProfileChickletHoverActions } from '../behaviors/socialProfile/SocialProfileChickletHoverActions';
import useEmptyCardFooterAction from '../behaviors/default/useEmptyCardFooterAction';
export const SocialProfile = {
  [CardAction]: () => SocialProfileCardAction,
  [ChickletPrimaryDisplayLabel]: () => SocialProfileChickletPrimaryDisplayLabel,
  [ChickletHoverActions]: () => SocialProfileChickletHoverActions,
  [CardFooterAction]: () => useEmptyCardFooterAction
};